import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/pages/Index/Index'//主页
import Scenic from '@/pages/Scenic/Scenic'//子页面
import Author from '@/pages/Author/Author'//微信授权页面
import Near from '@/pages/Near/Near'//附近搜索的点
import ScenicDetail from '@/pages/ScenicDetail/ScenicDetail'//景点详情





Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      redirect: {
        path: '/index'
      }
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      meta: {
        keepAlive: false, title: '前童镇全域旅游导览'
      }
    },
    {
      path: '/scenic',
      name: 'scenic',
      component: Scenic,
      meta: {
        keepAlive: true, title: ''
      }
    },
    {
      path: '/author',
      name: 'author',
      component: Author,
      meta: {
        keepAlive: false,
      }
    },
    {
      path: '/near',
      name: 'near',
      component: Near,
      meta: {
        keepAlive: false, title: '附近'
      }
    },

    {
      path: '/scenicDetail',
      name: 'scenicDetail',
      component: ScenicDetail,
      meta: {
        keepAlive: false, title: ''
      }
    },


  ]
})


export default router



// WEBPACK FOOTER //
// ./src/router/index.js